export const translation = {
  zenit: {
    ae: {
      siteTitle: `مكافآتك | Zenit`,
      bonusTitle: `رهان مجاني
         تصل قيمته
        حتى`,
      bonusTitleExtra: 'لأي عميل جديد',
      btnGetBonus: "أريد رهانًا مجانيًا!",
      step1: "سجل في Zenit وكيل المراهنات",
      step2: "أودع مبلغ 8 USD على الأقل",
      step3: "احصل على رهان مجاني بقيمة تساوي أول إيداعاتك",
      step4: "اتبع التعليمات واطلع على المستجدات!",
      benefit1: "مجموعة متنوعة من الرهانات لكل حدث",
      benefit2: "احتمالات مرتفعة",
      benefit3: "دعم 24 ساعة على مدار الأسبوع",
      benefit4: "سحب وإيداع سريع",
      rules: "الشروط والأحكام",
      regFormTitle: `Register
        and get the bonus!`
    },
    bn: {
      siteTitle: `আপনার বোনাস | Zenit`,
      bonusTitle: `যেকোনো 
        নতুন গ্রাহকের
        জন্য`,
      bonusTitleExtra: 'পর্যন্ত বিনামূল্যের বাজি',
      btnGetBonus: "আমি একটি বিনামূল্যের বাজি চাই!",
      step1: "বুকমেকার Zenit-এ নিবন্ধন করুন",
      step2: "কমপক্ষে 8 USD জমা করুন",
      step3: "আপনার প্রথম জমার সমান একটি বিনামূল্যের বাজি পান",
      step4: "নির্দেশাবলী অনুসরণ করুন এবং শীর্ষে থাকুন!",
      benefit1: "প্রত্যেক ইভেন্টে অনেক ধরনের বাজি",
      benefit2: "উচ্চ সম্ভাবনা",
      benefit3: "24/7 সহায়তা",
      benefit4: "দ্রুত উত্তোলন এবং জমাকরণ",
      rules: "শর্তাবলী",
      regFormTitle: `Register
        and get the bonus!`
    },
    br: {
      siteTitle: `Seus bônus | Zenit`,
      bonusTitle: `Uma aposta grátis
        de até`,
      bonusTitleExtra: `para qualquer
        novo cliente`,
      btnGetBonus: "Quero uma aposta grátis!",
      step1: "Cadastre-se na casa de apostas Zenit",
      step2: "Faça um depósito de pelo menos 8 USD",
      step3: "Obtenha uma aposta grátis igual ao seu primeiro depósito",
      step4: "Siga as instruções e fique por topo!",
      benefit1: "Grande variedade de apostas por evento",
      benefit2: "Altas probabilidades",
      benefit3: "Suporte 24/7",
      benefit4: "Saques e depósitos rápidos",
      rules: "Regras",
      regFormTitle: `REGISTRE-SE
        E OBTENHA UM BÔNUS!`
    },
    de: {
      siteTitle: `Ihre Boni | Zenit`,
      bonusTitle: `Eine Gratiswette
        im Wert
        von bis zu`,
      bonusTitleExtra: 'für jeden Neukunden',
      btnGetBonus: "Ich möchte eine Gratiswette!",
      step1: "Registrieren Sie sich beim Buchmacher Zenit",
      step2: "Tätigen Sie eine Einzahlung von mindestens 7 EUR",
      step3: "Erhalten Sie eine Gratiswette in Höhe Ihrer ersten Einzahlung",
      step4: "Befolgen Sie die Anweisungen und behalten Sie so den Überblick!",
      benefit1: "Breite Auswahl an Wetten auf Ereignisse",
      benefit2: "Hohe Quoten",
      benefit3: "24/7-Support",
      benefit4: "Schnelle Ein- und Auszahlungen",
      rules: "Regeln",
      regFormTitle: `Register
        and get the bonus!`
    },
    en: {
      siteTitle: 'Your bonuses | Zenit',
      bonusTitle: `A free bet worth
        up to`,
      bonusTitleExtra: `to any new customer`,
      btnGetBonus: "I want a free bet!",
      step1: "Register at Bookmaker Zenit",
      step2: "Make a deposit of at least 8 USD",
      step3: "Get a free bet equal to your first deposit",
      step4: "Follow the instructions and stay on top!",
      benefit1: "Wide range of bets per event",
      benefit2: "High odds",
      benefit3: "24/7 support",
      benefit4: "Quick withdrawals and deposits",
      rules: "Rules",
      regFormTitle: `Register
        and get the bonus!`
    },
    fr: {
      siteTitle: 'Vos bonus | Zenit',
      bonusTitle: `Un pari gratuit
        d'une valeur 
        de`,
      bonusTitleExtra: `offert à tout
        nouveau client`,
      btnGetBonus: "Je veux un pari gratuit!",
      step1: "Enregistrez-vous sur Bookmaker Zenit",
      step2: "Effectuez un dépôt d'au moins 7 EUR",
      step3: "Recevez un pari gratuit d'un montant égal à celui de votre premier dépôt",
      step4: "Suivez les instructions et restez en tête!",
      benefit1: "Large variété de paris par événement",
      benefit2: "Cotes élevées",
      benefit3: "Assistance 24/7",
      benefit4: "Retraits et dépôts rapides",
      rules: "Conditions générales",
      regFormTitle: `Register
        and get the bonus!`
    },
    ir: {
      siteTitle: 'پاداش‌های شما | Zenit',
      bonusTitle: `شرط رایگان
       تا مبلغ`,
      bonusTitleExtra: 'به هر شرط مشتری جدید',
      btnGetBonus: "من هم شرط رایگان می‌خواهم!",
      step1: "در بنگاه شرط‌بندی Zenit ثبت‌نام کنید",
      step2: "حداقل USD 8 واریز کنید",
      step3: "یک شرط رایگان معادل اولین واریزتان دریافت کنید",
      step4: "حتماً دستورالعمل‌ها را مطالعه کنید تا شانس برد بیشتری داشته باشید!",
      benefit1: "طیف وسیعی از ‌شرط برای هر رویداد",
      benefit2: "ضریب احتمال بالا",
      benefit3: "پشتیبانی هر روزه و همه ساعته",
      benefit4: "برداشت و واریز سریع",
      rules: 'شرایط و ضوابط',
      regFormTitle: `Register
        and get the bonus!`
    },
    kz: {
      siteTitle: `Сенің бонустарың | БК Зенит`,
      bonusTitle: `Жаңа ойыншыларға`,
      bonusTitleExtra: `дейін фрибет`,
      btnGetBonus: "Фрибетті алғым келеді!",
      step1: "Зенит букмекер кеңсесінде тіркел",
      step2: "Шотты 3500 тенге дейін толықтыр",
      step3: "Алғашқы депозит сомасына фрибетті қағып ал",
      step4: "Нұсқауларды орындап, ұтымды бол!",
      benefit1: "Іс -шаралардың кең ауқымы",
      benefit2: "Жоғары коэффициенттер",
      benefit3: "24/7 қолдау",
      benefit4: "Жылдам шешіп алу және толықтыру",
      rules: "Ережелер",
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    mx: {
      siteTitle: `Sus bonificaciones | Zenit`,
      bonusTitle: `Una apuesta gratuita
        de hasta`,
      bonusTitleExtra: `para cualquier
        nuevo cliente`,
      btnGetBonus: "¡Quiero una apuesta gratis!",
      step1: "Regístrese en Bookmaker Zenit",
      step2: "Hacer un depósito mínimo de 8 USD",
      step3: "Obtenga una apuesta gratuita igual a su primer depósito",
      step4: "¡Siga las instrucciones y manténgase en la cima!",
      benefit1: "Amplia gama de apuestas por evento",
      benefit2: "Grandes probabilidades",
      benefit3: "Las 24 horas del día, los 7 días de la semana",
      benefit4: "Retiros y depósitos rápidos",
      rules: "TÉRMINOS Y CONDICIONES",
      regFormTitle: `Register
        and get the bonus!`
    },
    ru: {
      siteTitle: `Фрибет до 5 000 р | БК Зенит`,
      bonusTitle: `Фрибет
        новым игрокам
        до`,
      bonusTitleExtra: '',
      btnGetBonus: "Хочу фрибет!",
      step1: "Регистрируйся в БК Зенит",
      step2: "Пополняй счет от 500 руб",
      step3: "Лови фрибет на сумму первого депозита",
      step4: "Следуй инструкциям и будь в плюсе!",
      benefit1: "Широкая роспись на события",
      benefit2: "Высокие кэфы",
      benefit3: "Поддержка 24/7",
      benefit4: "Быстрый вывод и пополнение",
      rules: "ПРАВИЛА",
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    sw: {
      siteTitle: `Bonasi zako | Zenit`,
      bonusTitle: `Dau isiyolipiwa ya kiasi
        cha hadi`,
      bonusTitleExtra: 'kwa mteja yeyote mpya',
      btnGetBonus: "Ninataka dau isiyolipiwa!",
      step1: "Jisajili kwenye Alamisho Zenit",
      step2: "Weka pesa zisizopungua 8 USD",
      step3: "Pata dau isiyolipiwa inayotoshana na pesa za kwanza ulizoweka",
      step4: "Fuata maagizo na umakinike!",
      benefit1: "Aina nyingi za dau kwa kila tukio",
      benefit2: "Malipo makubwa",
      benefit3: "Tunakusaidia 24/7",
      benefit4: "Kuweka na kutoa pesa haraka",
      rules: "SHERIA NA\xA0MASHARTI",
      regFormTitle: `Register
        and get the bonus!`
    },
    tr: {
      siteTitle: `Bonuslarınız | Zenit`,
      bonusTitle: `Her yeni müşteriye`,
      bonusTitleExtra: 'kadar ücretsiz bir bahis',
      btnGetBonus: "Ücretsiz bir bahis istiyorum!",
      step1: "Zenit Bahis Şirketine kaydolun",
      step2: "En az 8 USD para yatırın",
      step3: "İlk para yatırmanıza denk bir ücretsiz bahis alın",
      step4: "Talimatlara uyun ve zirvede kalın!",
      benefit1: "Etkinlik başına çok çeşitli bahis seçenekleri",
      benefit2: "Yüksek olasılıklar",
      benefit3: "7/24 destek",
      benefit4: "Hızlı para çekme ve yatırma işlemleri",
      rules: "HÜKÜM VE KOŞULLAR",
      regFormTitle: `Register
        and get the bonus!`
    },
    uz: {
      siteTitle: 'Bonuslaring | Zenit',
      bonusTitle: `Yangi o‘yinchilarga
        `,
      bonusTitleExtra: 'gacha fribet',
      btnGetBonus: "Fribet xohlayman!",
      step1: "Zenit BK da ro‘yxatdan o‘t",
      step2: "Hisobni k amida 500 rublga to‘ldir",
      step3: "Birinchi depozit summasiga teng fribetni ilib ol",
      step4: "Ko‘rsatmalarni bajar va pyusda bo‘l!",
      benefit1: "Hodisaga bo‘lgan keng ro‘yxat",
      benefit2: "Yuqori keflar",
      benefit3: "24/7 rejimidagi qo‘llab-quvvatlash",
      benefit4: "Tezkor chiqarib olish va to‘ldirish",
      rules: "QOIDALAR",
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    vi: {
      siteTitle: `Tiền thưởng của bạn | Zenit`,
      bonusTitle: `Đặt cược miễn 
        phí trị giá lên tới`,
      bonusTitleExtra: 'cho mọi khách hàng mới',
      btnGetBonus: "Tôi muốn cược miễn phí!",
      step1: "Đăng ký tại Nhà cái Zenit",
      step2: "Nạp tối thiểu 8 USD",
      step3: "Nhận cược miễn phí bằng với khoản tiền nạp đầu tiên của bạn",
      step4: "Thực hiện theo hướng dẫn và luôn dẫn đầu!",
      benefit1: "Phạm vi cược đa dạng trên mỗi sự kiện",
      benefit2: "Tỷ lệ cược cao",
      benefit3: "Hỗ trợ 24/7",
      benefit4: "Rút tiền và nạp tiền nhanh chóng",
      rules: "Điều khoản và\xA0điều\xA0kiện",
      regFormTitle: `Register
        and get the bonus!`
    }
  }
}